import { render, staticRenderFns } from "./TagDetail.vue?vue&type=template&id=3268de28&"
import script from "./TagDetail.vue?vue&type=script&lang=ts&"
export * from "./TagDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports